import React from 'react';
import validator from 'validator';
import { Form, Formik, Field } from 'formik';
import AutocompleteLocalidad from '../Commons/AutocompleteLocalidad.jsx';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { styled } from "@mui/material/styles";
import isMobile from 'ismobilejs';
import { stringify } from 'rebem-classname';

export default function RenderFormTurismo(props){
	const block = "RenderFormTurista";

	let formContactarOMensaje = (<Formik
		initialValues={{
			nombreApellido:'',
			telefono:'',
			email:'',
			localidad:null,
			mensaje:'',
		}}
		onSubmit={props.onSubmit}
		validate={
			({nombreApellido, telefono, email, localidad, mensaje})=>{
				let errores = {};
				if(!email){
					errores.email = 'El email es requerido';
				} else if(!validator.isEmail(email)){
					errores.email = 'El email ingresado no es valido';
				}
				if(!mensaje){
					errores.mensaje = 'El Comentario es requerido';
				} else if(mensaje.length>350) {
					errores.mensaje = 'El Comentario debe tener como maximo 350 caracteres';
				}
				if (!nombreApellido) {
					nombreApellido = 'Nombre es requerido';
				}
				if(!telefono) {
					telefono = 'Telefono es requerido';
				}
				return errores;
			}
		}
	>
		{({errors, touched}) => (<Form>
			<Field name="nombreApellido" placeholder="Nombre y Apellido * " className="" />
			{touched.nombreApellido && errors.nombreApellido && <div>{errors.nombreApellido}</div>}
			<Field name="telefono" type="tel" placeholder="Teléfono / Celular * " className=""/>
			{touched.telefono && errors.telefono && <div>{errors.telefono}</div>}
			<Field name="email" placeholder="Email " className=""/>
			{touched.email && errors.email && <div>{errors.email}</div>}
			<Field name="localidad">
				{({
					field: { value, onChange },
					form: { touched, errors, setFieldValue, values }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
					meta,
				}) => { 
					const onLugarClear = () => setFieldValue('localidad',null);
					const onLugarSelected = lugar => setFieldValue('localidad',lugar);
					const localidadConsultada = value;
					return <AutocompleteLocalidad
						onLugarClear={onLugarClear} 
						onLugarSelected={onLugarSelected}
						idProvincia={values && values.provincia ? values.provincia : null}
					/>
				}}
			</Field>
			{touched.localidad && errors.localidad && <div>{errors.localidad}</div>}
			<Field as="textarea" maxLength="350" name="mensaje" placeholder="Mensaje (*)" className=""/>
			{touched.mensaje && errors.mensaje && <div>{errors.mensaje}</div>}
			<button type="submit" className="btn btn-naranja">Enviar</button>
		</Form>)}
	</Formik>);

	if (props.mostrarMensajeDeEnvio) {
		formContactarOMensaje = <div className={stringify({block, elem:"mensaje_ok"})}>
			<span>Muchas Gracias por su contacto. Nos comunicaremos a la brevedad</span>
			<span className={stringify({block, elem:"ok glyphicon glyphicon-ok"})}></span>
		</div>
	}

	const DialogCustom = styled(Dialog)(() => ({
		"& .MuiDialog-paper": {
			padding: 5
		}
	}));

	return <div className={`container-fluid ${stringify({block})}`}>
		<div className={stringify({block, elem:"formularios"})}>
			<DialogCustom open={props.modalVisible} onClose={props.hideModal} fullScreen={isMobile.any}>
				<div className={stringify({block, elem:"contenido-modal"})}>
					<div className={stringify({block, elem:"titulo"})}>Sr. turista para reservar un alojamiento usted tiene que:</div>
					<div className={stringify({block, elem:"items"})}><span className={stringify({block, elem:"black"})}>-</span> Ir a  <a className={stringify({block, elem:"link"})} href='https://www.alquilerargentina.com'>www.AlquilerArgentina.com</a></div>
					<div className={stringify({block, elem:"items"})}><span className={stringify({block, elem:"black"})}>-</span> Buscar colocando la localidad de destino.</div>
					<div className={stringify({block, elem:"items"})}><span className={stringify({block, elem:"black"})}>-</span> Filtrar y Elegir los alojamientos</div>
					<div className={stringify({block, elem:"items"})}><span className={stringify({block, elem:"black"})}>-</span> Enviarle tu consulta al dueño o llamarlo por teléfono.</div>
					<div className={stringify({block, elem:"items"})}><span className={stringify({block, elem:"black"})}>Nota:</span> Si completa este formulario, será recibido por Alquiler Argentina.
					La empresa no intermedia en la reserva, ni busca alojamientos por usted.</div>
				</div>
				{isMobile.any && (
					<IconButton
						onClick={props.hideModal}
						color="primary"
						sx={{
							position: 'absolute',
							right: 8,
							top: 10
						}}
						>
						<CloseIcon />
					</IconButton>
				)}
			</DialogCustom>
			{formContactarOMensaje}
		</div>
	</div>
}
